import React from 'react';
import { ItemList } from '../../types/cycle';

type ControllerTabsProps = {
  list: ItemList[];
  editingController: string | null;
  onSelectTab: (serialNumber: string) => void;
  onRemoveTab?: (serialNumber: string) => void;
  disabled?: boolean;
};

// Shows the controllers already selected for this cycle as tabs, so it's
// always clear which controller's channels/thermocouples are being edited
// below, instead of the name only appearing in a column title.
const ControllerTabs: React.FC<ControllerTabsProps> = ({ list, editingController, onSelectTab, onRemoveTab, disabled }) => {
  if (!list.length) {
    return null;
  }

  return (
    <div className="c-controller-tabs flex flex-wrap gap-1.5 border-b border-stroke pb-0 dark:border-strokedark">
      {list.map((item) => {
        const isActive = editingController === item.serial_number;
        const selectedCount = item.channels.length + item.thermocouples.length;

        return (
          <button
            key={item.serial_number}
            type="button"
            disabled={disabled}
            onClick={() => onSelectTab(item.serial_number)}
            className={`c-controller-tabs__tab relative top-px flex max-w-[220px] items-center gap-2 truncate rounded-t-md border border-b-0 px-3.5 py-2 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
              isActive
                ? 'border-orange-300 bg-orange-100 text-black dark:border-orange-700 dark:bg-orange-900/40 dark:text-white'
                : 'border-transparent bg-transparent text-body hover:text-black dark:text-bodydark dark:hover:text-white'
            }`}
          >
            <span className="truncate">{item.name}</span>
            <span
              className={`flex-none rounded-full px-1.5 py-0.5 text-xs font-bold ${
                isActive ? 'bg-primary text-white' : 'bg-gray-2 text-body dark:bg-meta-4 dark:text-bodydark'
              }`}
            >
              {selectedCount}
            </span>
            {onRemoveTab && (
              <span
                role="button"
                aria-label={`Remove ${item.name}`}
                title={`Remove ${item.name}`}
                onClick={(event) => {
                  event.stopPropagation();
                  if (disabled) return;
                  onRemoveTab(item.serial_number);
                }}
                className={`flex-none rounded-full px-1 text-xs font-bold leading-none hover:text-danger ${
                  disabled ? 'pointer-events-none opacity-50' : ''
                }`}
              >
                ×
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default ControllerTabs;
